import React from "react";

const Exchanges = () => {
    return (
        <div>
            <h1>Exchanges under construction...</h1>
        </div>
    );
};

export default Exchanges;
